import type { Rating as RatingForApi } from '@/features/FeedbackForm/api/Feedback.types';

export enum Rating {
  GOOD = 'good',
  NORMAL = 'normal',
  BAD = 'bad',
}

export const RatingMap: Record<Rating, RatingForApi> = {
  [Rating.GOOD]: 2,
  [Rating.NORMAL]: 1,
  [Rating.BAD]: 0,
};
